import { render, staticRenderFns } from "./SanteSeniors.vue?vue&type=template&id=107e595e&"
import script from "./SanteSeniors.vue?vue&type=script&lang=js&"
export * from "./SanteSeniors.vue?vue&type=script&lang=js&"
import style0 from "./SanteSeniors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports